import { ClassValue } from "clsx/clsx";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Allow to combine Tailwind class merging with Tailwind object composition by combining clsx and tailwind-merge.
 * Further watching: https://www.youtube.com/watch?v=re2JFITR7TI
 * @param inputs - Tailwind classes to merge
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
